import { useId } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const buttonStyle = {
  width: '100%',
  height: '40px',
  borderRadius: 8,
  border: '1px solid rgba(255,255,255,0.25)',
  background: 'rgba(255,255,255,0.05)',
  color: '#fff',
  fontSize: 16,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
};

const selectedStyle = { background: '#2e7be7', border: '1px solid #2e7be7' };

const ToolButton = ({ tooltip, ariaLabel = tooltip, selected, disabled, onClick, children }) => {
  const tooltipId = useId();
  return (
    <OverlayTrigger
      placement="top"
      delay={{ show: 200, hide: 100 }}
      overlay={
        <Tooltip className="responder-tooltip" id={tooltipId}>
          {tooltip}
        </Tooltip>
      }
    >
      <span className="d-inline-flex w-100">
        <button
          type="button"
          className="w-100"
          style={{
            ...buttonStyle,
            ...(selected ? selectedStyle : {}),
            ...(disabled ? { pointerEvents: 'none' } : {}),
          }}
          aria-label={ariaLabel}
          aria-pressed={selected}
          disabled={disabled}
          onClick={onClick}
        >
          {children}
        </button>
      </span>
    </OverlayTrigger>
  );
};

const GeometryToolsPanel = ({
  activeMode,
  onSetMode,
  onUndo,
  onRedo,
  onCancel,
  canReshape = true,
  canResize = true,
  canRotate = true,
  canAddVertex = true,
  canEraseVertex = true,
  canUndo = false,
  canRedo = false,
}) => (
  <div
    role="group"
    aria-label="Geometry editing tools"
    className="d-grid mb-2"
    style={{ gridTemplateColumns: 'repeat(3, 1fr)', gap: 8 }}
  >
    <ToolButton
      tooltip="Select and move shape"
      ariaLabel="Move"
      selected={activeMode === 'move'}
      onClick={() => onSetMode('move')}
    >
      {'\u2196'}
    </ToolButton>
    <ToolButton
      tooltip="Reshape by moving one vertex at a time"
      ariaLabel="Reshape"
      selected={activeMode === 'reshape'}
      disabled={!canReshape}
      onClick={() => onSetMode('reshape')}
    >
      {'\u270e'}
    </ToolButton>
    <ToolButton
      tooltip="Resize entire shape"
      ariaLabel="Resize"
      selected={activeMode === 'resize'}
      disabled={!canResize}
      onClick={() => onSetMode('resize')}
    >
      {'\u2922'}
    </ToolButton>
    <ToolButton
      tooltip="Rotate entire polygon"
      ariaLabel="Rotate"
      selected={activeMode === 'rotate'}
      disabled={!canRotate}
      onClick={() => onSetMode('rotate')}
    >
      {'\u21bb'}
    </ToolButton>
    <ToolButton
      tooltip="Add vertex on polygon border"
      ariaLabel="Add vertex"
      selected={activeMode === 'addVertex'}
      disabled={!canAddVertex}
      onClick={() => onSetMode('addVertex')}
    >
      {'\uff0b'}
    </ToolButton>
    <ToolButton
      tooltip="Erase vertex"
      ariaLabel="Erase vertex"
      selected={activeMode === 'eraseVertex'}
      disabled={!canEraseVertex}
      onClick={() => onSetMode('eraseVertex')}
    >
      {'\u232b'}
    </ToolButton>
    <ToolButton tooltip="Undo" disabled={!canUndo} onClick={onUndo}>
      {'\u21ba'}
    </ToolButton>
    <ToolButton tooltip="Redo" disabled={!canRedo} onClick={onRedo}>
      {'\u21bb'}
    </ToolButton>
    <ToolButton
      tooltip="Cancel and restore previous geometry"
      ariaLabel="Cancel"
      disabled={!canUndo}
      onClick={onCancel}
    >
      {'\u00d7'}
    </ToolButton>
  </div>
);

export default GeometryToolsPanel;
